export type Theme = "light" | "dark" | "system";

export function applyStoredTheme(): Theme {
  const theme = readTheme();
  applyTheme(theme);
  return theme;
}

export function setTheme(theme: Theme): void {
  try {
    if (theme === "system") window.localStorage.removeItem(THEME_KEY);
    else window.localStorage.setItem(THEME_KEY, theme);
  } catch {}
  applyTheme(theme);
}

export function readTheme(): Theme {
  try {
    const stored = window.localStorage.getItem(THEME_KEY);
    return stored === "light" || stored === "dark" ? stored : "system";
  } catch {
    return "system";
  }
}

export function accountTheme(themeType: string | null | undefined): Theme {
  if (themeType === "LIGHT") return "light";
  if (themeType === "DARK") return "dark";
  return "system";
}

function applyTheme(theme: Theme): void {
  if (theme === "system") document.documentElement.removeAttribute("data-theme");
  else document.documentElement.setAttribute("data-theme", theme);
}

const THEME_KEY = "simon.theme";
